import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "react";
import { AddAlertModal } from "@/modals/organizations/add-alert-modal";

export function OrganizationSettingsAlertMenu() {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Button
				variant="primary"
				onClick={disclosure.onOpen}
				icon={<Icon name="Plus" />}
			>
				{t("dashboard.alerts.add_alert")}
			</Button>
			{disclosure.isOpen && (
				<AddAlertModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
